import { TimeBucket_TimeSeries, timeBucket_TimeSeriesToJSON } from "../../proto/generated/common";
import { ChartType, chartTypeToJSON } from '../../proto/generated/chart'


export enum FeatureCategory {
    CHART = 'CHART',
    SIMULATOR = 'SIMULATOR',
    TRADING = 'TRADING',
    MULTI_STRIKE = 'MULTI_STRIKE',
    SCREENER = 'SCREENER',
    STRATEGY_CHART = 'STRATEGY_CHART',
    SCALPER = 'SCALPER',
    STRATEGY_BUILDER = 'STRATEGY_BUILDER',
    WATCHLIST = 'WATCHLIST',
    /** Catalog category for ADMIN_ACCESS product entitlement (display name: ADMIN ACCESS). */
    ADMIN_ACCESS = 'ADMIN_ACCESS',
}

export enum FeatureSubCategory {
    TIMEBUCKET = 'TIMEBUCKET',
    CHART_TYPE = 'CHART_TYPE',
    INDICATOR = 'INDICATOR',
    ALERTS = 'ALERTS',
    OI_CHARTS = 'OI_CHARTS',
    MULTIPANE = 'MULTIPANE'
}

export enum FeatureName {
    // TimeBucket features
    SECONDS = 'SECONDS',
    MINUTES = 'MINUTES',
    HOURS = 'HOURS',
    CHART_TIMEBUCKET_SECONDS = 'CHART_TIMEBUCKET_SECONDS',
    CUSTOM_TIME_BUCKETS = 'CUSTOM_TIME_BUCKETS',
    PAYOFF_CHART_INTERACTIONS = 'PAYOFF_CHART_INTERACTIONS',
    
    // ChartType features
    CANDLESTICK = 'CANDLESTICK',
    LINE = 'LINE',
    AREA = 'AREA',

    // ChartIndicator features
    OI_INDICATORS = 'OI_INDICATORS',
    VOLUME_PROFILE_INDICATORS = 'VOLUME_PROFILE_INDICATORS',

    // Other chart features
    CHART_SPLIT = 'CHART_SPLIT',
    DATA_EXPORT = 'DATA_EXPORT',
    TRADE_FROM_CHART = 'TRADE_FROM_CHART',
    PAST_EXPIRY = 'PAST_EXPIRY',
    SECURITY_EXPRESSIONS = 'SECURITY_EXPRESSIONS',

    // Screener features
    SCREENER_DATA_EXPORT = 'SCREENER_DATA_EXPORT',
    SCREENER_SUBSCRIPTION = 'SCREENER_SUBSCRIPTION',

    // Trading features
    SL_AND_TARGET = 'SL_AND_TARGET',

    STRATEGY_BUILDER_ACCESS = 'STRATEGY_BUILDER_ACCESS',

    // Product feature access
    SIMULATOR_ACCESS = 'SIMULATOR_FULL_ACCESS',
    MULTI_STRIKE_ACCESS = 'MULTI_STRIKE_FULL_ACCESS',
    SCALPER_ACCESS = 'SCALPER_FULL_ACCESS',

    // Strategy Chart features
    STRATEGY_CHART_ACCESS = 'STRATEGY_CHART_ACCESS',

    // Watchlist features
    COMMUNITY_WATCHLIST_ACCESS = 'COMMUNITY_WATCHLIST_ACCESS',

    /** Product admin gate — attach to ADMIN plan; not identity ADMIN role */
    ADMIN_ACCESS = 'ADMIN_ACCESS',
}

export const timeSeriesFeatureMap: Record<TimeBucket_TimeSeries, string> = {
    [TimeBucket_TimeSeries.TIME_SERIES_UNKNOWN]: 'UNKNOWN',
    [TimeBucket_TimeSeries.SECOND]: FeatureName.SECONDS,
    [TimeBucket_TimeSeries.MINUTE]: FeatureName.MINUTES,
    [TimeBucket_TimeSeries.HOUR]: FeatureName.HOURS,
    [TimeBucket_TimeSeries.DAY]: 'DAYS',
    [TimeBucket_TimeSeries.WEEK]: 'WEEKS',
    [TimeBucket_TimeSeries.MONTH]: 'MONTHS',
    [TimeBucket_TimeSeries.YEAR]: 'YEARS',
    [TimeBucket_TimeSeries.UNRECOGNIZED]: 'UNRECOGNIZED'
}

export const getTimeBucketFeatureName = (timeSeries: TimeBucket_TimeSeries): string => {
    return timeSeriesFeatureMap[timeSeries] || timeBucket_TimeSeriesToJSON(timeSeries)
}

export const getChartTypeCodes = (): string[] => {
    return [
        chartTypeToJSON(ChartType.CANDLESTICK),
        chartTypeToJSON(ChartType.LINE),
        chartTypeToJSON(ChartType.BAR),
        chartTypeToJSON(ChartType.AREA),
        chartTypeToJSON(ChartType.HEIKIN_ASHI),
        chartTypeToJSON(ChartType.COLUMN),
        chartTypeToJSON(ChartType.KAGI),
        chartTypeToJSON(ChartType.HOLLOW_CANDLES),
        chartTypeToJSON(ChartType.HIGH_LOW),
        chartTypeToJSON(ChartType.BASELINE),
        chartTypeToJSON(ChartType.HLC_AREA)
    ].filter(code => code !== 'CHART_TYPE_UNKNOWN' && code !== 'UNRECOGNIZED')
}
